export default {
  getPlayBook: state => state.playBook,
};
